const NEEDS_QUOTES = /[",\r\n]/;
const REVOKE_DELAY_MS = 1000;

function field (value) {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return NEEDS_QUOTES.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

// RFC 4180. columns: [{ header, value }] where value is a property name or a
// function of the row.
export function toCsv (columns, rows) {
  const lines = [columns.map(c => field(c.header)).join(',')];
  (rows || []).forEach(row => {
    lines.push(columns.map(c => field(typeof c.value === 'function' ? c.value(row) : row[c.value])).join(','));
  });
  return lines.join('\r\n') + '\r\n';
}

export function downloadText (filename, text, mime = 'text/csv') {
  const url = URL.createObjectURL(new Blob([text], { type: `${mime};charset=utf-8;` }));
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}
